import { LitElement, html } from 'lit-element';

class AppFooter extends LitElement {
    static get properties() {
        return {};
    }

    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }

    render() {
        const currentYear = new Date().getFullYear();

        return html`
            <div class="footer-container">
                <div class="copyright">© ${currentYear} <span>UI UX Guide</span>. All rights reserved.</div>

                <div class="message">
                    <span>
                        Created with
                        <svg
                            class="w-6 h-6 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="#e37a70"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z"
                            />
                        </svg>
                        by Akriti Singh.
                    </span>
                </div>

                <div class="links">
                    <a href="https://akritisingh.com/projects" class="footer-link" tabindex="0" aria-label="My Projects"
                        >My Projects</a
                    >
                    <a href="https://akritisingh.com/about-me" class="footer-link" tabindex="0" aria-label="About Me"
                        >About Me</a
                    >
                    <a
                        href="https://akritisingh.com/contact-me"
                        class="footer-link"
                        tabindex="0"
                        aria-label="Contact Me"
                        >Contact Me</a
                    >
                </div>
            </div>
        `;
    }
}

customElements.define('app-footer', AppFooter);
